import React from "react";

const ObrigacoesAdvertenciasCard = ({ obrigacoesAdvertencias }) => (
  <div className="col-lg-12">
    <div className="card shadow mb-1">
      <div className="card-header">
        <b>{obrigacoesAdvertencias?.titulo}</b>
      </div>
      <div className="card-body">
        <table className="table table-striped table-bordered" width="100%">
          <thead>
            <tr>
              <th>
                <center>
                  <b>Descrição da Obrigação</b>
                </center>
              </th>
            </tr>
          </thead>
          <tbody>
            {obrigacoesAdvertencias?.obrigacoes?.map((obrigacao) => (
              <tr>
                <td>
                  <center>
                    {obrigacao.flagTitulo === "N" ? (
                      obrigacao.descricaoObrigacao
                    ) : (
                      <strong className="header">{obrigacao.descricaoObrigacao}</strong>
                    )}
                  </center>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default ObrigacoesAdvertenciasCard;
